module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "menu"
  }, [_c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n    General\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("Home")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "menu-label"
  }, [_vm._v("\n    Transactions\n  ")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/history"
    }
  }, [_vm._v("History")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/transfer"
    }
  }, [_vm._v("Transfer")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-351b5566","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 160
// module chunks = 0